import React from 'react';
import { Button } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import { css } from '@emotion/react';
import { colors } from '@/styles';

const LegAddButton = ({ children, ...rest }) => (
    <Button
        fullWidth
        variant="outlined"
        startIcon={<AddIcon fontSize="small" />}
        css={css`
            justify-content: flex-start;
            height: 40px;
            text-transform: none;
            font-weight: 500;
            color: ${colors.greys[3]};
            background: ${colors.white.secondary};
            border-color: ${colors.greys.border};
        `}
        {...rest}
    >
        {children}
    </Button>
);

export default LegAddButton;
